module.exports = __webpack_public_path__ + "img/book.56f72031.svg";